module.exports = __webpack_public_path__ + "media/img/event/profiling-result-tablet-26b67aef623727e9605943b5332c06fb.png";